export default "__VITE_ASSET__DgsjwUhw__"